<script setup>
import { ref, defineProps, defineEmits } from "vue";

const props = defineProps({
  img: String,
  title: String,
  text: String,
  button: String,
  selected: Boolean,
  styleClass: String,
});

const emits = defineEmits(["cardButtonClick"]);

const isSelected = ref(props.selected);

function toggleSeleccionado() {
  isSelected.value = !isSelected.value;
  // Emitir un evento cuando se hace clic en el botón de la tarjeta
  emits("cardButtonClick", props.title);
}
</script>
<template>
  <div :class="['card', 'gap-4', props.styleClass]">
    <header class="d-flex align-items-center h-25 justify-content-around">
      <div style="display: flex; width: 25%">
        <img class="card-img" :src="img" alt="imagen" />
      </div>

      <h3 class="h3">
        {{ title }}
      </h3>
    </header>
    <article style="min-height: 8rem; padding-top: 1rem">
      <p class="p">
        {{ text }}
      </p>
    </article>
    <footer class="d-flex justify-content-center">
      <button
        style="max-width: 8rem"
        class="globals-button"
        :class="{ selected: selected }"
        @click="toggleSeleccionado"
      >
        {{ button }}
      </button>
    </footer>
  </div>
</template>
<style>
img {
  width: 6rem;
  height: 6rem;
}
</style>
